<script setup lang="ts">
  import type { ToastItem } from '@liebherr/patternlib/loader';
  import { onBeforeMount, provide, ref } from 'vue';

  const Window = window;

  const toast = ref<HTMLPatternlibToastElement>();
  const toastPosition = ref<
    | 'bottom-right'
    | 'top-left'
    | 'top-right'
    | 'top-center'
    | 'bottom-left'
    | 'bottom-center'
    | undefined
  >('bottom-right');
  const displayBreakpoint = ref<string>('isDesktop');

  const createToast = async (
    toastMessage: string,
    toastType: ToastItem['type'] = 'warning'
  ) => {
    let toastCustomContent = '';
    toastPosition.value = 'bottom-right';

    //check for link in message and set custom content, because 'message' prop doesn't support html in message
    if (toastMessage.includes('</a>')) {
      toastCustomContent = toastMessage;
      toastPosition.value = 'bottom-center';
    }

    await toast.value?.createToastItem({
      message: toastMessage,
      showIcon: true,
      type: toastType,
      showUndo: false,
      autoHide: true,
      delay: 6000,
      customContent: toastCustomContent
    });
  };

  const getDisplayBreakpoint = () => {
    return document.documentElement.getAttribute('breakpoint') ?? 'isDesktop';
  };

  provide('createToast', createToast);

  const displayBreakpointObserver = new ResizeObserver(() => {
    if (!document.documentElement.getAttribute('breakpoint')) {
      displayBreakpoint.value = 'isDesktop';
      return;
    }

    displayBreakpoint.value = getDisplayBreakpoint();
  });
  displayBreakpointObserver.observe(document.body);

  onBeforeMount(async () => {
    document.documentElement.setAttribute('data-context', 'portal');
    document.documentElement.setAttribute('data-theme', 'hau');
  });

  displayBreakpoint.value = getDisplayBreakpoint();
  provide('displayBreakpoint', displayBreakpoint);
</script>

<template>
  <router-view></router-view>

  <!-- Toast -->
  <patternlib-toast
    ref="toast"
    :position="toastPosition"
    :width="Math.min((80 * Window.innerWidth) / 100, 650) + 'px'"
  ></patternlib-toast>
</template>

<style lang="scss" scoped>
  @import 'modules/@liebherr/patternlib/dist/patternlib/patternlib.css';

  .w-700 {
    max-width: 700px;
  }
</style>
